// Theme Main JS
import '../vendor/brooklyn';

// Styles
import '../../styles/style.scss';

// Scripts
import '../vendor/slick/slick.js';
import '../vendor/ProxyLink.js';
import '../vendor/TimedPopup.js';
import '../vendor/parsley.js';
import Tabs from '../components/tabs.js';
import '../components/gsap-collapse.js';
//import '../components/sparkle';
import '../components/knitkit.js';
import '../components/input.js';
import '../sections/strip-slideshow.js';
import '../sections/collection-slider.js';
import '../sections/section-collection-side-carousel.js';
import '../components/header.js';
import '../components/drawer.js';
import '../components/facets.js';
import {showLargeFilters} from '../components/facets.js';
import '../components/cookie-banner.js';
/* import '../components/$.ClipIt.js'; */
import NewsletterForm from '../components/newsletter-form.js';
import '../sections/slideshow.js';
import '../sections/hero-cards.js';
// import '../sections/collection-carousel.js';
import '../snippets/contact-form.js';
//import '../sections/featured-products.js';
import '../sections/featured-description.js';
import '../sections/featured-services.js';
import '../sections/template_product.js';
import '../sections/page-contact.js';
import '../sections/newsletter-popup.js';
import '../snippets/product-tile.js';
import '../snippets/wishlist.js';
import { capitalize } from '../helpers.js';
//import '../snippets/dataLayer.js';
import '../sections/section-products-carousel.js';
import '../sections/multi-carousel.js';
import '../sections/press-pages.js';
import '../sections/section-carousel-blog.js';



if(window.dAgency && window.dAgency.marketsConfiguration) {
    window.dAgency.marketsConfiguration.getDefaultIsoCodeFromMarketConfiguration = getDefaultIsoCodeFromMarketConfiguration;
} else {
    window.dAgency = {}
    window.dAgency.marketsConfiguration = {}
}

// Safeguard: prevent calling slick methods on non-initialized elements
if (window.jQuery) {
    (function($){
        var _origSlick = $.fn.slick;
        $.fn.slick = function() {
            // If calling a method (first arg is string) ensure slider is initialized
            if (arguments.length && typeof arguments[0] === 'string') {
                if (!this || !this.length) return this;
                if (!this.hasClass('slick-initialized')) {
                    return this; // silently ignore calls on non-initialized elements
                }
            }
            return _origSlick.apply(this, arguments);
        };
    })(window.jQuery);
}

$(document).on('ready', function() {
    Tabs();
    NewsletterForm();

    if(typeof window.Ajaxinate !== 'undefined' && document.getElementById('AjaxinateContainer')) {

        var anchorStart = window.location.href.indexOf('#');
        var itemID = anchorStart != -1 ? window.location.href.substr(anchorStart) : '';
        var preLoadingEnded = true; // Flag to check if were loading back pages
        var ajaxPageParamStart = window.location.href.indexOf('?i=');
        var ajaxPageParamEnd = anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
        var ajaxPageNumber = ajaxPageParamStart != -1 ? parseInt(window.location.href.substr(ajaxPageParamStart, ajaxPageParamEnd).replace('?i=', '')) : false;

        var preLoadNextPage = function() {
            window.endlessScroll.currentPage++
            window.endlessScroll.pagesToLoad--;

            window.setTimeout(function(){
                if(window.endlessScroll.nextPageLinkElement){
                    window.endlessScroll.nextPageUrl = window.endlessScroll.nextPageLinkElement.getAttribute('href');
                    window.endlessScroll.loadMore();
                }
            }, 10); // Please lord of javascript forgive me for this!


            if(!window.endlessScroll.pagesToLoad) {
                preLoadingEnded = true;
            }
        }

        if(document.querySelector('#AjaxinatePagination .pagination a')){
            document.querySelector('#AjaxinatePagination .pagination a').addEventListener('click', function(event){
                event.target.classList.add('loading');
            });
        }

        showLargeFilters($('.facets__display'));

        var scrollHeight = $(window).scrollTop();

        // Re-initialize components after AJAX load
        const reinitializeProductTiles = function() {
            // Re-trigger lazy loading for images
            if (window.lazySizes) {
                window.lazySizes.rv = [];
            }
            
            // Reinitialize image hover effect
            const $newTiles = $('#AjaxinateContainer').find('[data-img-change="true"]');
            $newTiles.each(function() {
                const $wrapper = $(this).find('.product--wrapper');
                if ($wrapper.length) {
                    $wrapper.off('mouseenter mouseleave');
                    $wrapper.on('mouseenter', function() {
                        $(this).find('.product-tile__image-wrapper--hover').fadeIn(200);
                    });
                    $wrapper.on('mouseleave', function() {
                        $(this).find('.product-tile__image-wrapper--hover').fadeOut(200);
                    });
                }
            });
            
            // Dispatch custom event for other components to reinitialize
            document.dispatchEvent(new CustomEvent("dagency:tiles-loaded"));
        };

        window.endlessScroll = new Ajaxinate({
          container: '#AjaxinateContainer',
          pagination: '#AjaxinatePagination',
          method: 'scroll',
          callback: function(requestURL, $html){
                // First, reinitialize all components
                reinitializeProductTiles();
                
                var $proxyLinks = $('#AjaxinateContainer').find('[data-link-proxy]');

                if($proxyLinks.length > 1) {
                    $proxyLinks.off('click');

                    $proxyLinks.ProxyLink({
                        excludes: ['.slick-dots', '.product-tile__variant', '.swym-add-to-wishlist-view-product' ],
                        onBeforeUnload: function($proxyLink) {
                            const itemID = $proxyLink.data('pid');

                            if(itemID) {
                                const requestedPageNum = requestURL.substr(requestURL.indexOf('?page=')).replace('?page=', '');
                                history.replaceState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + '#' + itemID);
                            }
                        }
                    });
                }

                // Init wishlist buttons
                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

                // Scroll back to latest position
                var requestedPageNum = requestURL.substr(requestURL.indexOf('?page=')).replace('?page=', '');

                if(requestedPageNum && document.querySelector('[data-paginate="' + requestedPageNum + '"]')) {
                    var scrollPosition = document.querySelector('[data-paginate="' + requestedPageNum + '"]').offsetTop;
                    window.scrollTo({left: 0, top: scrollPosition});
                }

                    if(preLoadingEnded) {
                        window.endlessScroll.currentPage = requestedPageNum;
                        history.replaceState({}, 'page ' + requestedPageNum, '?i='+requestedPageNum + itemID);
                    }

                    if(!window.endlessScroll.pagesToLoad) {
                        const headersHeight = $('.site-header').outerHeight(true);

                        if(itemID) {
                            var itemTop = $(itemID).offset().top - headersHeight;
                            window.scrollTo({left:0, top:itemTop, behavior: 'smooth'});
                            itemID = '';
                        }
                    }

                    if(window.endlessScroll.pagesToLoad) {
                        preLoadNextPage();
                    }

                    const pagination = $html.find('#ProductGridContainer .products-count').get(0);

                    if(pagination) {
                        const pag_n = pagination.getAttribute('data-pagination');
                        document.querySelector('#ProductGridContainer .products-count span').innerHTML= pag_n;
                    }

                    if (document.querySelector('#AjaxinatePagination .pagination a')) {
                        document.querySelector('#AjaxinatePagination .pagination a').classList.remove('loading');
                        document.querySelector('#AjaxinatePagination .pagination a').addEventListener('click', function(event){
                            event.target.classList.add('loading');
                        });
                    }
                }
        });

        window.endlessScroll.currentPage = 1;

        if(ajaxPageNumber) {
            window.scrollTo({left:0, top: 0});
            preLoadingEnded = false;
            window.endlessScroll.pagesToLoad = ajaxPageNumber - 1;
            preLoadNextPage();
        }
    }




    const $orderLists = $('[data-order-list]');
    if($orderLists.length) {
        $orderLists.each(function(){
            const $list = $(this);
            $list.find('[data-order-number]').sort(function(a, b) {
                return +a.dataset.orderNumber - +b.dataset.orderNumber;
            })
            .appendTo($list);
        });
        window.setTimeout(function(){
            $orderLists.attr('data-order-list', 'ready');
        }, 50);
    }

    showLargeFilters($('.facets__display'));



    function getCookie(cookieName) {
        let cookie = {};
        document.cookie.split(';').forEach(function(el) {
          let [key,value] = el.split('=');
          cookie[key.trim()] = value;
        })
        return cookie[cookieName];
    }
});




